export const environment = {
    production: false,
    // apiUrl: 'http://localhost:8090',
    apiUrl: 'https://dev.referio.be',
    frontUrl: 'https://frontend.referio.be'
};
